import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const getOrder = async(orderId) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/order/" + orderId, 
    { headers: AuthHeader.authHeader()});
    console.log("ORDER RESPONSE" , response);  
    return response.data;
  };

const submitOrder = async(orderId, paymentType) => {
  console.log("IN SUBMIT CART");
  try {
      const response = await axios.post(process.env.REACT_APP_API_URL + "/submitorder", 
      { "orderId" : orderId,
        "paymentType": paymentType }, 
      { headers: AuthHeader.authHeader()});
      console.log("ORDER RESPONSE" , response);
      return response.data;
    } catch (error) {
      console.log("SUBMIT ORDER ERROR", error.response.data.error);
      if(error.response && error.response.data && error.response.data.error) {
        if(error.response.data.error === "NOT_ENOUGH_FUNDS") {
          return {error: "error", message: "Your balance is less than the order total. Please refesh the page and pay the remainder of your balance with a credit card."};

        } else {
          return {error: "error", message: error.response.data.error };

        }
      } else {
        return {error: "error", message: "An error occurred while submitting your order. Please try again"};
      }
    }    
  };

const getOpenOrders = async() => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/orders/open", 
  { headers: AuthHeader.authHeader()});
  return response.data;
};

const updateBillingAddress = async(billingAddressId) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/order/updateAddress", 
  { billingAddressId: billingAddressId }, 
  { headers: AuthHeader.authHeader()});
  return response.data;
}

const orderNewHireKit = async(items, address) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/order/newhirekit", 
  { items: items,
    address: address
   }, 
  { headers: AuthHeader.authHeader()});
  return response.data;
};
const OrderService = {
    getOrder,
    submitOrder,
    getOpenOrders,
    updateBillingAddress,
    orderNewHireKit
};
export default OrderService;